import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './App.css';

const API_BASE = 'https://qbo.omnivistaweb.com';

const Login = () => {
  const [authUrl, setAuthUrl] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    // If already authenticated, skip login
    const isAuthenticated = localStorage.getItem('authenticated') === 'true';
    if (isAuthenticated) {
      navigate('/salary-dashboard');
    }

    axios.get(`${API_BASE}/api/start-auth`).then(res => {
        setAuthUrl(res.data.authorize_url);
      })
      .catch(() => {
        console.error("Failed to get auth URL");
      });
  }, [navigate]);

  const handleLogin = async () => {
    // Clear previous config to force new code
    await axios.post(`${API_BASE}/api/clear-auth`);
    if (authUrl) {
      window.location.href = authUrl;
    }
  };
  

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: '#f9fafb' }}>
      <div style={{ textAlign: 'center', background: '#fff', padding: 40, borderRadius: 8, boxShadow: '0 0 10px rgba(0,0,0,0.1)' }}>
        <h2 style={{ fontSize: 28, marginBottom: 20 }}>Welcome to GenAiWPS</h2>
        <p style={{ marginBottom: 30 }}>Please log in to continue</p>
        <button
          onClick={handleLogin}
          style={{ backgroundColor: '#0077cc', color: 'white', border: 'none', padding: '12px 24px', fontSize: 16, borderRadius: 4, cursor: 'pointer' }}
        >
          Login with QuickBooks
        </button>
      </div>
    </div>
  );
};

export default Login;
